<template>
  <v-navigation-drawer
    width="200"
    :clipped="$vuetify.breakpoint.lgAndUp"
    v-model="menudata.drawer"
    class="menu-sidebar"
    fixed
    app
  >
    <v-flex class="subtitle-menu">
      <p>{{ T("MENU") }}</p>
    </v-flex>
    <!-- {{features.userinfo.nome}} -->

    <v-list dense>
      <template v-for="item in menudata.items">
        <v-list-group
          v-if="item.children"
          v-model="item.model"
          :key="item.text"
          :prepend-icon="item.icon"
          :append-icon="item['icon-alt']"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title class="meta-menutext">{{
                T(item.text)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :href="`#/admin/app/${child.url}`"
            v-for="(child, i) in item.children"
            :key="i"
          >
            <v-list-tile-action v-if="child.icon" style="padding-left: 4px;">
              <!-- <v-icon>{{ child.icon }}</v-icon> -->

              <i
                data-v-4bd958a0
                aria-hidden="true"
                class="v-icon mdi mdi-checkbox-blank-circle-outline theme--light"
                style="font-size: 16px;"
              ></i>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title class="meta-menutext">{{
                T(child.text)
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-tile v-else :key="item.text" @click="navegar(item)">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="meta-menutext">{{
              T(item.text)
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: ["menudata", "profile"],
  data: () => ({
    features: global.features,
  }),
  methods: {
    navegar(item) {
      this.$router.push({ path: `/admin/app/${item.url}` });
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$router.replace({
        name: "admin-login",
      });
    },
  },
};
</script>

<style>
.meta-menutext {
  color: #fff;
}
</style>
